/**
 * Stories scroller image visibility.
 */

'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'storiesScroller', () => ({

		active: false,

		init() {

			const content = this.$el.querySelector( '.stories-scroller__content > div' );

			// Set "active" to true if the element is at least to mid-viewport.
			if ( content.getBoundingClientRect().top < window.innerHeight / 2 ) {
				this.active = true;
			}

			// Set "active" to true when element scrolls to the bottom third of
			// the viewport.
			window.addEventListener( 'scroll', () => {
				if ( content.getBoundingClientRect().top < window.innerHeight / 3 * 2 ) {
					this.active = true;
				}
			});

			// Set "active" to false when the element scrolls below the viewport.
			window.addEventListener( 'scroll', () => {
				if ( content.getBoundingClientRect().top > window.innerHeight ) {
					this.active = false;
				}
			});
		},
	}) );
});
